import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import {
  editForm,
  confirmForm,
  INSURANCE_CONTACT_FORM,
} from '../Actions/actions';
import { formName } from '../Constants/constants';
import InsuranceContact from '../Components/InsuranceContact/InsuranceContact';

const formValues = formValueSelector(formName);

const fieldSelect = (state, fieldName) => {
  if (state.formPage.insuranceContact.contactSame) {
    return fieldName
      ? formValues(state, `insured${fieldName}`)
      : state.formPage.insured.insuredRenter;
  }
  return fieldName
    ? formValues(state, `contact${fieldName}`)
    : state.formPage.insuranceContact.contactRenter;
};

const mapStateToProps = (state) => ({
  enabled: state.formPage.insuranceContact.enabled,
  confirmed: state.formPage.insuranceContact.confirmed,
  valid: state.formPage.insuranceContact.valid,
  contactPhone: formValues(state, 'contactPhone'),
  contactEmail: formValues(state, 'contactEmail'),
  contactSame: state.formPage.insuranceContact.contactSame,
  contactRenter: fieldSelect(state),
  contactFirstName: formValues(state, 'contactFirstName'),
  contactLastName: formValues(state, 'contactLastName'),
  contactCompany: fieldSelect(state, 'Company'),
  contactAddress: fieldSelect(state, 'Address'),
  contactCity: fieldSelect(state, 'City'),
  contactState: fieldSelect(state, 'State'),
  contactZip: fieldSelect(state, 'Zip'),
  contactCountry: fieldSelect(state, 'Country'),
  usStates: state.formPage.usStates,
});

const mapDispatchToProps = (dispatch) => ({
  edit: () => dispatch(editForm(INSURANCE_CONTACT_FORM)),
  confirm: () => dispatch(confirmForm(INSURANCE_CONTACT_FORM)),
});

const InsuranceContactContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InsuranceContact);

export default InsuranceContactContainer;
